import React from "react";
import {Navigate} from "react-router-dom";
import {LOCAL_SESSION} from "../constants/local-entity";
import {dropLocal, localSession} from "../helpers/local-storage";

const RequireAuth = props => {
  const {children} = props;

  const session = localSession.getItem(LOCAL_SESSION);

  if (session?.Respuesta === 1) return children;
  dropLocal(LOCAL_SESSION);
  return <Navigate replace to="/" />;
};

export default RequireAuth;
